function affiliates_Reducer(state = [], action) {
    switch (action.type) {
        case 'AFFILIATES/SET':
            return action.affiliates;
        case 'AFFILIATES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default affiliates_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/affiliates.js